import React, { useEffect, useRef, useState } from 'react';
import * as ArrayExtensions from '../../../utils/CoreExtensions/ArrayExtensions';
import ChrDivider from './ChrDivider';
import ChrLink from './ChrLink';
import { actionStatus } from '../FilterUI/constants';

const ChrPopover = props => {
  const popoverRef = useRef(null);
  const [popoverStyle, setPopoverStyle] = useState({});

  const getActionClass = (action) => {
    return action.state === actionStatus.DISABLED ? "text-muted" : "";
  }

  const getActionCallback = (action) => {
    return action.state === actionStatus.DISABLED ? null : action.callback;
  }

  useEffect(() => {
    if (popoverRef.current && props.parentWrapperRef?.current) {
      const parentRect = props.parentWrapperRef.current.getBoundingClientRect();
      const popoverRect = popoverRef.current.getBoundingClientRect();
      const windowWidth = window.innerWidth;

      if (parentRect.left + popoverRect.width > windowWidth)
        setPopoverStyle({ right: windowWidth - parentRect.right })
      else
        setPopoverStyle({});
    }
  }, [props.children]);

  return (
    <div
      ref={popoverRef}
      className={`
        bg-white m-t-xs position-absolute z-index-5 shadow d-flex flex-column ${props.dimensionClasses} ${props.additionalClasses}
      `}
      style={popoverStyle}
    >
      <div className="overflow-scroll p-xs">
        { props.children }
      </div>
      { ArrayExtensions.isPresent(props.actions) &&
        <React.Fragment>
          <div><ChrDivider additionalClasses="no-padding" /></div>
          <div className="p-xs ml-auto mb-auto">
            {
              props.actions.map(action => {
                return (
                  <ChrLink
                    noHref
                    key={ action.label }
                    tabIndex='0'
                    className={ `px-2 ${getActionClass(action)}` }
                    onClick={ getActionCallback(action) }
                  >
                    { action.label }
                  </ChrLink>
                );
              })
            }
          </div>
        </React.Fragment>
      }
    </div>
  );
};

export default ChrPopover;